// 优惠券优先级（数字越大优先级越高）
export const COUPON_PRIORITY = {
  DISTRIBUTION_ALL: 100,
  DISTRIBUTION_SPECIFIC: 90,
  NEW_USER_EXCLUSIVE: 50,
  NORMAL_COUPON: 10,
} as const;

// 活动启用开关
export const CAMPAIGN_ENABLE = {
  firstOrder: true,
  distribution: true,
} as const;

// 本地存储键名
export const STORAGE_KEYS = {
  FIRST_ORDER_MODAL_SHOWN: 'fc_first_order_modal_shown',
} as const;

export const MOCK_ENABLE = false;
